<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Centro de Distribuição | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
          <div class="form-group col-12 col-md-6">
            <label for="descricao">Descrição: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.descricao }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="status_desc">Status: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.status_desc }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="telefone">Telefone: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.telefone }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_cep">CEP: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_cep }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_logradouro">Logradouro: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_logradouro }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_numero">Número: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_numero }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_complemento">Complemento: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_complemento }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_bairro">Bairro: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_bairro }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_cidade">Cidade: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_cidade }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_uf">UF: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_uf }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_pais">País: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.pais.descricao }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_latitude">Latitude: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_latitude }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_longitude">Longitude: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_longitude }}
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Voltar</button>
            <button type="button" id="editarButton" class="btn btn-info" @click="editar()">Editar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Formatters from '../../helpers/Formatters'
import Actions from '../../actions/CentroDistribuicaoActions'

export default {
  name: 'detalhes',
  props: ['id'],
  data () {
    return {
      registro: {
        descricao: '',
        telefone: '',
        end_cep: '',
        end_logradouro: '',
        end_numero: '',
        end_complemento: '',
        end_bairro: '',
        end_cidade: '',
        end_uf: '',
        end_pais: '',
        end_latitude: '',
        end_longitude: '',
        status_desc: '',
        pais: {
          descricao: ''
        }
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Detalhes'

    Actions.obterCentroDistribuicao(this.id)
      .then(res => {
        if (res && res.descricao) {
          this.registro = res

          this.registro.telefone = Formatters.formataNumeroTelefone(this.registro.telefone)
          this.registro.end_cep = Formatters.formataCep(this.registro.end_cep)

          this.registro.pais = this.registro.pais === null ? { descricao: null } : this.registro.pais
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }
      })
      .catch((error) => {
        console.log(error.message)
        this.errorMessage = 'Registro não encontrado.'
      })
  },
  methods: {
    voltar () {
      this.$router.push('/centro-distribuicao')
    },
    editar () {
      this.$router.push('/centro-distribuicao/' + this.id + '/e')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/centro-distribuicao/Detalhes.vue